<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width"
      :style="{ height: '76px' }"
    >
      <div class="flex items-center">
        <span class="text-lg text-neutral text-weight-medium q-mr-md">
          Detailed Analysis
        </span>
      </div>

      <PBtn color="primary" flat round @click="onClose">
        <CloseIcon class="icon" />
      </PBtn>
    </header>
    <q-separator color="neutral-40" />
    <div class="q-px-2x-md q-pt-xl col overflow-auto">
      <div v-for="(directorAnalysis, index) in computedAnalysis" :key="index">
        <div class="row q-col-gutter-x-xxl q-mt-sm">
          <div class="col-6">
            <div class="text-sm text-neutral-80">Credit Score</div>
            <div class="text-sm text-neutral text-weight-medium">
              {{ directorAnalysis.credit_score || "-" }}
            </div>
          </div>
          <div class="col-6">
            <div class="text-sm text-neutral-80">GST Exempted</div>
            <div class="text-sm text-neutral text-weight-medium">
              {{ (directorAnalysis.gst_exempted ? "YES" : "NO") || "-" }}
            </div>
          </div>
        </div>
        <div class="row q-col-gutter-x-xxl q-mt-sm">
          <div class="col-6">
            <div class="text-sm text-neutral-80">Balance</div>
            <div class="text-sm text-neutral text-weight-medium">
              {{ directorAnalysis.balance || "0" }}
            </div>
          </div>
          <div class="col-6">
            <div class="text-sm text-neutral-80">DOI</div>
            <div class="text-sm text-neutral text-weight-medium">
              {{
                formatDate(directorAnalysis.incorporation_date, "D MMM YYYY") ||
                "-"
              }}
            </div>
          </div>
        </div>
        <div class="row q-col-gutter-x-xxl q-mt-sm">
          <div class="col-6">
            <div class="text-sm text-neutral-80">Delinquencies</div>
            <div class="text-sm text-neutral text-weight-medium">
              {{ directorAnalysis.delinquency || "0" }}
            </div>
          </div>
          <div class="col-6">
            <div class="text-sm text-neutral-80">GST Registration</div>
            <div class="text-sm text-neutral text-weight-medium">
              {{
                formatDate(directorAnalysis.registration_date, "D MMM YYYY") ||
                "-"
              }}
            </div>
          </div>
        </div>
        <div class="row q-col-gutter-x-xxl q-mt-sm">
          <div class="col-6">
            <div class="text-sm text-neutral-80">Legal Case Exists</div>
            <div
              class="text-sm text-neutral text-weight-medium text-capitalize"
            >
              {{ directorAnalysis.legal_cases || "-" }}
            </div>
          </div>
          <div class="col-6">
            <div class="text-sm text-neutral-80">GST Filing Status</div>
            <div class="text-sm text-neutral text-weight-medium">
              {{ directorAnalysis.gst_filing_status || "-" }}
            </div>
          </div>
        </div>
        <div class="row q-col-gutter-x-xxl q-mt-sm">
          <div class="col-6">
            <div class="text-sm text-neutral-80">Director Name</div>
            <div
              class="text-sm text-neutral text-weight-medium text-capitalize"
            >
              {{ directorAnalysis.director_name || "-" }}
            </div>
          </div>
        </div>
        <q-separator color="neutral-40" class="q-my-sm" />
      </div>
    </div>
  </div>
</template>
<script setup>
import CloseIcon from "assets/icons/close.svg";
import { date } from "quasar";
const { formatDate } = date;

const { togglePreScreeningDetailForm } = useUserStore();

const props = defineProps({
  analysis: {
    type: Object,
    default: () => ({}),
  },
});

const computedAnalysis = computed({
  get() {
    return props.analysis;
  },
});

const onClose = () => {
  togglePreScreeningDetailForm({ open: false, level: 1 });
};
</script>
